import { createStore } from "redux";
import infoReducer from "./add/addReducer";

const store = createStore(infoReducer);

export default store;
